<template>
  <v-main class="fondo">
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-card
          width="400"
          class="py-6 px-10 text-center"
          elevation="4"
          style="margin-top: -20px; min-width: 300px"
        >
          <img :src="`${$global.ruta}/${$global.URLParams}.png`" style="max-height: 80px; max-width: 200px" />
          <div class="text-h5" style="color: #bc8d3c">Zona privada</div>
          <div class="mt-8 text-h6" style="color: #31708f">Recuperar contraseña</div>
          <v-text-field
            ref="inputCorreoElectronico"
            class="mt-1"
            label="Correo electrónico"
            prepend-inner-icon="mdi-email"
            :rules="[rules.required]"
            v-model="email"
            type="email"
            spellcheck="false"
            @blur="completarEmail()"
            @keypress.enter="recuperarContrasena"
          ></v-text-field>
          <v-btn
            class="mt-2"
            block
            large
            color="primary"
            elevation="2"
            :disabled="!datosRellenos"
            @click="recuperarContrasena"
          >Recuperar</v-btn>
          <div class="mt-5">
            <router-link to="/">
              <a>Iniciar sesión</a>
            </router-link>
          </div>
        </v-card>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import api from "@/api";

export default {
  data: () => ({
    rules: {
      required: (value) => !!value || "Requerido",
    },
    email: "",
  }),
  methods: {
    completarEmail() {
 /*     if (this.email != "" && !this.email.includes("@"))
        this.email = this.email + "@gmp.es";*/
    },
    recuperarContrasena() {
      console.log(this.email);
      api.recuperarContrasena(this.email);
    },
  },
  computed: {
      datosRellenos() {
      return this.email != "";
    },
  },
  mounted() {
    this.$refs["inputCorreoElectronico"].focus();
  },
};
</script>

<style>
</style>